// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral/module';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useCallIndependentAmount = () => {
  const { submit } = useExerciseSubmission(
    CollateralAgreement.CollateralAgreement_CallIndependentAmount,
    'Successfully called independent amount',
    'Failed to call independent amount',
  );
  return submit;
};
